import React from "react";
import { formatRoute } from "react-router-named-routes";
import constants from "../../Utils/constants";
import { icons } from "./icons/Icons";
import Slugify from "../../Utils/Slugify";

// object for mapping report type to show path
export const MappinReportType = {
  company: "Company Research",
  companies: "Company Research",
  benchmark: "Benchmark",
  customer_study: "Customer Study",
  ecosystem: "Ecosystem",
  market_forecast: "Market Forecast",
  market_landscape: "Market Landscape",
  project: "Project",
  special_report: "Special Report",
};

// function for report type path
export const getReportTypeLabel = (type) => {
  return MappinReportType[type] || type || "N/A";
};

export const redirectToReport = (item) => {
  let redirectPath = "";

  // Map item type to their respective route
  switch (item.type) {
    case "company":
      redirectPath = constants.APPLICATION_ROUTE.COMPANY.VIEW.ROUTE;
      break;
    case "benchmark":
      redirectPath = constants.APPLICATION_ROUTE.BENCHMARK.VIEW.ROUTE;
      break;
    case "customer_study":
      redirectPath = constants.APPLICATION_ROUTE.CUSTOMER_STUDIES.VIEW.ROUTE;
      break;
    case "ecosystem":
      redirectPath = constants.APPLICATION_ROUTE.ECOSYSTEM.VIEW.ROUTE;
      break;
    case "market_forecast":
      redirectPath = constants.APPLICATION_ROUTE.MARKET_FORECAST.VIEW.ROUTE;
      break;
    case "market_landscape":
      redirectPath = constants.APPLICATION_ROUTE.MARKET_LANDSCAPE.VIEW.ROUTE;
      break;
    case "project":
      redirectPath = constants.APPLICATION_ROUTE.PROJECT.VIEW.ROUTE;
      break;
    case "special_report":
      redirectPath = constants.APPLICATION_ROUTE.SPECIAL_REPORTS.VIEW.ROUTE;
      break;
    default:
      return ""; // return empty string if no valid type
  }

  // Format the base path
  let formattedPath = formatRoute(redirectPath, {
    id: item.type === "company" ? item.company_id : item.mapping_id,
  });

  // making a key for specific content redirection
  const key = `#${Slugify(item?.subcategory_name)}_${item?.subcategory_id}`;

  // If it's a company, append the segment query param
  if (item.type === "company") {
    return `${formattedPath}?segment=${item?.segment_id}${key}`;
  } else {
    formattedPath = `${formattedPath}${key}`;
  }

  return formattedPath;
};

export const renderIcon = (type, method) => {
  if (method === "content") {
    switch (type) {
      case "company":
        return (
          <span className="companyresearch-icon">
            <img
              src={icons.companyResearch.value}
              alt={icons.companyResearch.label}
            />
          </span>
        );
      case "benchmark":
        return (
          <span className="benchmark-icon">
            <img src={icons.benchmarks.value} alt={icons.benchmarks.label} />
          </span>
        );
      case "market_forecast":
        return (
          <span className="marketforcast-icon">
            <img
              src={icons.marketForecasts.value}
              alt={icons.marketForecasts.label}
            />
          </span>
        );
      case "market_landscape":
        return (
          <span className="marketlandscape-icon">
            <img
              src={icons.marketLandscapes.value}
              alt={icons.marketLandscapes.label}
            />
          </span>
        );
      case "special_report":
        return (
          <span className="specialreports-icon">
            <img
              src={icons.specialReports.value}
              alt={icons.specialReports.label}
            />
          </span>
        );
      case "customer_study":
        return (
          <span className="customerstudies-icon">
            <img
              src={icons.customerStudies.value}
              alt={icons.customerStudies.label}
            />
          </span>
        );
      case "ecosystem":
        return (
          <span className="ecosystems-icon">
            <img src={icons.ecosystems.value} alt={icons.ecosystems.label} />
          </span>
        );
      case "project":
        return (
          <span className="ecosystems-icon">
            <img src={icons.projects.value} alt={icons.projects.label} />
          </span>
        );
      default:
        return null;
    }
  } else {
    return (
      <span className="pdf-icon">
        <img src={icons.pdf.value} alt={icons.pdf.label} />
      </span>
    );
  }
};
